import { render, staticRenderFns } from "./addressForm.vue?vue&type=template&id=a98734ce&"
import script from "./addressForm.vue?vue&type=script&lang=js&"
export * from "./addressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports